import { companionPalette } from "./companionPalette";

/** The same creature as a flat-shaded SVG. */
export function CompanionFallback({ hue }: { hue: number }) {
  const palette = companionPalette(hue);
  const id = `cf${hue}`;
  return (
    <svg viewBox="0 0 100 100" className="h-full w-full">
      <defs>
        <radialGradient id={`${id}b`} cx="36%" cy="30%" r="80%">
          <stop offset="0%" stopColor={palette.light} />
          <stop offset="55%" stopColor={palette.base} />
          <stop offset="100%" stopColor={palette.dark} />
        </radialGradient>
      </defs>
      <ellipse cx="50" cy="92" rx="26" ry="4" fill="#1e293b" opacity="0.14" />
      <line x1="50" y1="22" x2="50" y2="10" stroke={palette.dark} strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="50" cy="9" r="4.5" fill={palette.belly} />
      <ellipse cx="38" cy="86" rx="9" ry="5" fill={palette.dark} />
      <ellipse cx="62" cy="86" rx="9" ry="5" fill={palette.dark} />
      <ellipse cx="50" cy="56" rx="32" ry="30" fill={`url(#${id}b)`} />
      <ellipse cx="50" cy="68" rx="18" ry="13" fill={palette.belly} opacity="0.9" />
      <ellipse cx="40" cy="52" rx="4.5" ry="5.5" fill="#1e1b3a" />
      <ellipse cx="60" cy="52" rx="4.5" ry="5.5" fill="#1e1b3a" />
      <circle cx="38.5" cy="50" r="1.6" fill="#fff" />
      <circle cx="58.5" cy="50" r="1.6" fill="#fff" />
      <circle cx="31" cy="60" r="4" fill="#ff8fb8" opacity="0.55" />
      <circle cx="69" cy="60" r="4" fill="#ff8fb8" opacity="0.55" />
      <path d="M46 60 Q50 64 54 60" stroke="#6b1d3a" strokeWidth="1.8" fill="none" strokeLinecap="round" />
    </svg>
  );
}
